import { render, staticRenderFns } from "./DashboardVehicleState.vue?vue&type=template&id=1fff5d97&scoped=true&"
import script from "./DashboardVehicleState.vue?vue&type=script&lang=ts&"
export * from "./DashboardVehicleState.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardVehicleState.vue?vue&type=style&index=0&id=1fff5d97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff5d97",
  null
  
)

export default component.exports